/** Событие, которое открывает поиск по бэкофису (⌘K) из любой кнопки. */
export const OPEN_COMMAND_PALETTE = "backoffice:open-search"

export const openCommandPalette = () => window.dispatchEvent(new Event(OPEN_COMMAND_PALETTE))
